var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcastIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1693_11205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 48.5685 50.5685 62 34 62C17.4315 62 4 48.5685 4 32C4 15.4315 17.4315 2 34 2C50.5685 2 64 15.4315 64 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 32C63.5 48.2924 50.2924 61.5 34 61.5C17.7076 61.5 4.5 48.2924 4.5 32C4.5 15.7076 17.7076 2.5 34 2.5C50.2924 2.5 63.5 15.7076 63.5 32Z",
    stroke: "#EBEBEB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4003 41.929L35.7785 39.8321L38.4432 38.2779L37.5555 34.8878L35.3542 32.9538L36.7296 31.7373L36.231 29.832L34.0233 31.784L31.8222 29.8501L31.324 31.7531L32.6959 32.9586L30.499 34.9011L29.6104 38.2926L32.2792 39.8381L28.651 41.9537L28.0234 44.3505C28.0811 44.3247 27.6637 44.5653 34.0304 40.8519C40.392 44.5351 39.972 44.2928 40.0268 44.3224L39.4003 41.929ZM34.0269 38.8183L30.8223 36.9629L34.0269 34.1281L37.2354 36.9472L34.0269 38.8183Z",
    fill: "#394D5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.403 41.929C38.9197 41.6492 39.5264 42.0007 35.7812 39.8321C38.5499 38.2172 38.0959 38.4819 38.4459 38.2779L37.5582 34.8878C37.033 34.4267 37.3245 34.6829 35.357 32.9538C36.6579 31.8032 36.4146 32.0184 36.7324 31.7373L36.2337 29.832C35.9056 30.1219 36.2758 29.7945 34.0312 31.7794V34.13L37.2381 36.9472L34.0312 38.8171V40.8531L34.0331 40.8519C40.4819 44.5855 39.9754 44.2931 40.0295 44.3224L39.403 41.929Z",
    fill: "#233138"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.762 46.126C43.762 46.6114 43.3682 47.0052 42.883 47.0052H25.1915C24.7063 47.0052 24.3125 46.6114 24.3125 46.126C24.3125 45.6408 24.7063 45.247 25.1915 45.247H26.2828L31.3321 25.9733C31.693 26.5171 32.2153 26.9462 32.83 27.1928L28.1001 45.247H39.9749L35.2452 27.1924C35.8599 26.9455 36.382 26.5167 36.7431 25.9727L41.7922 45.247H42.883C43.3682 45.247 43.762 45.6408 43.762 46.126Z",
    fill: "#394D5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7561 46.126C43.7561 46.6114 43.3623 47.0052 42.8771 47.0052H34.0312V45.247H39.969C39.9093 45.0185 35.25 27.234 35.2393 27.1924C35.854 26.9455 36.3761 26.5167 36.7372 25.9727C36.892 26.5643 41.7621 45.1543 41.7863 45.247H42.8771C43.3623 45.247 43.7561 45.6408 43.7561 46.126Z",
    fill: "#233138"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0327 20.6846C32.0849 20.6846 30.5 22.2621 30.5 24.2015C30.5 26.1411 32.0849 27.7189 34.0327 27.7189C35.9808 27.7189 37.5654 26.1411 37.5654 24.2015C37.5654 22.2621 35.9808 20.6846 34.0327 20.6846Z",
    fill: "#FD4235"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0312 20.6846V27.7189C35.9811 27.7189 37.564 26.1388 37.564 24.2019C37.564 22.2626 35.9793 20.6846 34.0312 20.6846Z",
    fill: "#EB1102"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3936 29.5009C24.062 29.5009 23.7447 29.3124 23.5959 28.9919C22.1877 25.9622 22.1859 22.4439 23.5959 19.4101C23.8003 18.9698 24.3231 18.7788 24.7634 18.9835C25.2037 19.188 25.3946 19.7107 25.1901 20.151C24.5985 21.4241 24.2986 22.7869 24.2986 24.201C24.2986 25.6153 24.5985 26.9779 25.1901 28.2509C25.4612 28.8348 25.0322 29.5009 24.3936 29.5009Z",
    fill: "#FFC543"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3881 31.4026C21.0673 31.4026 20.7582 31.2263 20.6032 30.9206C18.4663 26.7042 18.4649 21.7011 20.6032 17.4817C20.8228 17.0487 21.3519 16.8756 21.7849 17.0952C22.2179 17.3146 22.391 17.8435 22.1716 18.2767C20.2882 21.9928 20.2868 26.407 22.1716 30.1259C22.4684 30.7118 22.0395 31.4026 21.3881 31.4026Z",
    fill: "#FFC543"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5989 27.022C25.9053 25.2138 25.9037 23.1932 26.5989 21.3809C26.7727 20.9276 27.281 20.7011 27.7346 20.8749C28.1877 21.0489 28.4144 21.5572 28.2403 22.0106C27.7176 23.3736 27.686 24.9471 28.2403 26.3923C28.4144 26.8454 28.1877 27.354 27.7346 27.5278C27.2814 27.7015 26.7729 27.4755 26.5989 27.022Z",
    fill: "#FFC543"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6763 29.5009C43.0377 29.5009 42.6082 28.835 42.8798 28.2509C43.4714 26.9781 43.7714 25.6155 43.7714 24.201C43.7714 22.7867 43.4714 21.4241 42.8798 20.1513C42.6751 19.711 42.866 19.188 43.3063 18.9835C43.7469 18.7788 44.2694 18.9698 44.474 19.4101C45.882 22.4395 45.884 25.9585 44.474 28.9921C44.3252 29.3124 44.0076 29.5009 43.6763 29.5009Z",
    fill: "#FF9900"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6794 31.4025C46.0282 31.4025 45.5991 30.712 45.8961 30.1258C47.609 26.7463 47.8158 22.1798 45.8373 18.2766C45.6179 17.8434 45.791 17.3145 46.224 17.0951C46.6572 16.8758 47.1861 17.0486 47.4057 17.4818C49.6516 21.9132 49.4155 27.0707 47.4643 30.9205C47.3093 31.2262 47.0002 31.4025 46.6794 31.4025Z",
    fill: "#FF9900"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6452 27.5864C40.0297 27.5864 39.6041 26.9675 39.8246 26.3923C40.0924 25.6937 40.2285 24.9567 40.2285 24.2013C40.2285 23.4462 40.0927 22.7092 39.8246 22.0106C39.6508 21.5572 39.8772 21.0489 40.3306 20.8749C40.7837 20.7011 41.2922 20.9276 41.466 21.3809C41.8115 22.2812 41.9865 23.2301 41.9865 24.2013C41.9865 25.1726 41.8115 26.1217 41.466 27.022C41.3321 27.3716 40.9987 27.5864 40.6452 27.5864Z",
    fill: "#FF9900"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1693_11205",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1693_11205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1693_11205",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastIcon);
export default __webpack_public_path__ + "static/media/BroadcastIcon.4c5e7bed42024eca3f530d6dc8336883.svg";
export { ForwardRef as ReactComponent };